import { Utils } from '../utils';
import httpClient from '../utils/httpClient';
import { buildPatientFilesFormData, isLocalPatientFile } from '../utils/patientFiles';

export const uploadPatientFiles = async (formData) => {
	return httpClient({
		method: 'post',
		url: '/upload/patient-files',
		data: formData,
		headers: {
			authorization: Utils.getAuthToken()
		}
	});
};

export const uploadTaggedPatientFiles = async ({ patientId, taggedFiles }) => {
	const localTaggedFiles = taggedFiles.filter(({ file }) => isLocalPatientFile(file));

	if (!localTaggedFiles.length) {
		return { data: [], error: null };
	}

	const formData = buildPatientFilesFormData(patientId, localTaggedFiles);

	const { data, error } = await uploadPatientFiles(formData);

	if (error) {
		return { data: null, error };
	}

	return { data: Array.isArray(data) ? data : [], error: null };
};
